import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { paymentRepository } from '../repositories/payment.repository';
import { paymentKeys } from '../services/payments.keys';
import type { Payment } from '../types/payment.types';

export function usePayments() {
  const { currentOrganization } = useOrganization();

  return useQuery<Payment[]>({
    queryKey: paymentKeys.byOrg(currentOrganization?.id || ''),
    queryFn: () => {
      if (!currentOrganization?.id) {
        throw new Error('No organization selected');
      }
      return paymentRepository.fetchPayments(currentOrganization.id);
    },
    enabled: !!currentOrganization?.id,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
